import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isAssignTagRequestFailure() {
      return getState().isFailure;
    },
    isAssignTagRequestPending() {
      return getState().isPending;
    },
    isAssignTagRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export { createSelector };
